import script from "./CardWithGradient.vue?vue&type=script&setup=true&lang=js"
export * from "./CardWithGradient.vue?vue&type=script&setup=true&lang=js"

import "./CardWithGradient.vue?vue&type=style&index=0&id=335c5100&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-335c5100"]])

export default __exports__